import request from '@/utils/request'

let Store_hfApi = {

  /*门店入驻H5列表*/
  list(data) {
    return request._post('/shop/plus.store_hf.Index/index', data);
},
/*添加门店入驻H5*/
add(data) {
    return request._post('/shop/plus.store_hf.Index/add', data);
},
/*修改门店入驻H5*/
edit(data) {
    return request._post('/shop/plus.store_hf.Index/edit', data);
},
/*删除门店入驻H5*/
del(data) {
    return request._post('/shop/plus.store_hf.Index/del', data);
},
/*门店入驻H5详情*/
detail(data) {
  return request._post('/shop/plus.store_hf.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.store_hf.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.store_hf.Setting/getSetting', data, errorback);
    },
}
export default Store_hfApi;



// WEBPACK FOOTER //
// ./src/api/store_hf.js